/* Dawn search modal, including external branded header launchers. */
if (!customElements.get('details-modal')) {
  customElements.define('details-modal', class DetailsModal extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.key === 'Escape' || event.code === 'Escape') { event.stopPropagation(); this.close(); }
      });
      this.summaryToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.isOpen() ? this.close() : this.open(event, this.summaryToggle);
      });
      this.querySelector('.modal__close-button, button[type="button"]').addEventListener('click', () => this.close());
      this.summaryToggle.setAttribute('role', 'button');
      this.onBodyClickEvent = (event) => {
        if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
      };
    }
    isOpen() { return this.detailsContainer.hasAttribute('open'); }
    open(event, opener) {
      if (event) event.stopPropagation();
      if (!this.isOpen()) {
        this.returnFocus = opener || this.summaryToggle;
        this.expansionControl = event && event.currentTarget && event.currentTarget.matches('summary, .pp-nav-search, .pp-mobile-search') ? event.currentTarget : this.summaryToggle;
        this.hadScrollLock = document.body.classList.contains('overflow-hidden');
      }
      this.detailsContainer.setAttribute('open', '');
      this.summaryToggle.setAttribute('aria-expanded', 'true');
      this.expansionControl.setAttribute('aria-expanded', 'true');
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');
      const content = this.querySelector('[tabindex="-1"]');
      trapFocus(content, this.querySelector('input:not([type="hidden"])') || content);
    }
    close(focusToggle = true) {
      if (!this.isOpen()) return;
      const predictive = this.querySelector('predictive-search');
      if (predictive && typeof predictive.close === 'function') predictive.close();
      this.detailsContainer.removeAttribute('open');
      this.summaryToggle.setAttribute('aria-expanded', 'false');
      if (this.expansionControl) this.expansionControl.setAttribute('aria-expanded', 'false');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      if (!this.hadScrollLock) document.body.classList.remove('overflow-hidden');
      removeTrapFocus(focusToggle ? this.returnFocus : null);
    }
    disconnectedCallback() {
      if (this.isOpen()) this.close(false);
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  });
}
